// extracted by mini-css-extract-plugin
module.exports = {"desc_section":"style_desc_section__28U5A","desc_section__title":"style_desc_section__title__21LJC","desc_section__text":"style_desc_section__text__W5OcY"};